//----------------------------------------------------------------------------------------------------------------------
// Entity Proxy
//
// Creates a Proxy around GameEntityManager that resolves unknown property access via getByName(),
// while falling through to real methods and properties on the manager.
//----------------------------------------------------------------------------------------------------------------------

import type { GameEntityManager } from '../managers/entity.ts';

//----------------------------------------------------------------------------------------------------------------------

export function createEntityProxy(entityManager : GameEntityManager) : GameEntityManager & Record<string, unknown>
{
    return new Proxy(entityManager, {
        get(target : GameEntityManager, prop : string | symbol) : unknown
        {
            if(typeof prop === 'symbol')
            {
                return Reflect.get(target, prop);
            }

            // If the property exists on the target (method or own property), use it
            if(prop in target)
            {
                const val = Reflect.get(target, prop);
                if(typeof val === 'function')
                {
                    return val.bind(target);
                }
                return val;
            }

            // Otherwise try to resolve as an entity name
            return target.getByName(prop);
        },
    }) as GameEntityManager & Record<string, unknown>;
}

//----------------------------------------------------------------------------------------------------------------------
